import { Button } from "../../../../components/Button/Button.tsx";

export const BrandKitSection = ({
  title,
  isLoading,
  onAdd,
  children,
}: {
  title: string;
  isLoading?: boolean;
  onAdd: () => void;
  children: React.ReactNode;
}) => (
  <div className="flex-col gap-400">
    <div className="flex-row items-center justify-between">
      <div className="heading-xl">{title}</div>
      <Button
        iconName="Plus"
        variant="secondary"
        onClick={onAdd}
        loading={isLoading}
      >
        Add
      </Button>
    </div>
    {children}
  </div>
);
